import { FC, useEffect } from 'react';

import { ItemSource } from '@common/type/GoogleTagType';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useInView } from 'react-intersection-observer';

import CardCarousel from '@components/molecules/courseCard/section/cardCarousel';
import CourseCardSectionStyle from '@components/organisms/sections/courseCard/style';
import { useCourseSuggestion } from '@hooks/course/useCourseSuggestion';

const MAXIMUM_COURSE = 20;

type CourseSuggestionProps = {
  courseIdName: string;
};

const CourseSuggestion: FC<CourseSuggestionProps> = ({ courseIdName }) => {
  const { t } = useTranslation('store_course');

  const { handleFetchCourseSuggestions, courseSuggestionsData } = useCourseSuggestion({
    idName: courseIdName,
  });

  const courseSuggestions = courseSuggestionsData?.courses || [];
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0, rootMargin: '450px' });

  useEffect(() => {
    if (inView) {
      handleFetchCourseSuggestions();
    }
  }, [handleFetchCourseSuggestions, courseIdName, inView]);

  return (
    <Box ref={ref}>
      {inView && courseSuggestions.length > 0 ? (
        <Box py={{ lg: 1 }}>
          <CourseCardSectionStyle>
            <Typography variant="h1" component="h2" mb="22px">
              {t('course_detail.course_suggestion.title')}
            </Typography>
            <CardCarousel
              courses={courseSuggestions}
              maxItems={MAXIMUM_COURSE}
              itemSource={ItemSource.COURSE_SUGGESTION}
            />
          </CourseCardSectionStyle>
        </Box>
      ) : null}
    </Box>
  );
};

export default CourseSuggestion;
